/**
 * Helper function to get the website's base URL
 */
export const getBaseUrl = (): string => {
  if (process.env.NEXT_PUBLIC_BASE_URL) {
    return process.env.NEXT_PUBLIC_BASE_URL;
  }
  if (process.env.NEXT_PUBLIC_ALIAS_URL) {
    return process.env.NEXT_PUBLIC_ALIAS_URL;
  }
  return 'http://localhost:3024';
};
